import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config-service/app-config.service';
import { LoggingService } from '../logging-service/logging.service';
import { AuthHttpClient } from '../auth-http-service/auth-http.service';

@Injectable()
export class QuestionnaireService {

  constructor(private appConfigService: AppConfigService, private loggingService: LoggingService, private http: AuthHttpClient) { }

  getPhrEpaDefinition() {
    this.loggingService.log("Getting EPA Questionnaire Definition", this.appConfigService.LogToConsole)
    return this.http.get(this.appConfigService.GetPhrEpaDefinition.replace('{PregnancyId}',this.appConfigService.PregnancyId.toString()));
  }

  getBirthPlanEpaDefinition() {
    this.loggingService.log("Getting Birth Plan Questionnaire Definition", this.appConfigService.LogToConsole)
    return this.http.get(this.appConfigService.GetPhrBirthPlanDefinition.replace('{PregnancyId}',this.appConfigService.PregnancyId.toString()));
  }

  postEpaQuestionnaireDefinition(definition: any) {
    this.loggingService.log("Posting EPA Questionnaire Definition", this.appConfigService.LogToConsole)
    return this.http.post(this.appConfigService.PostPhrEpaDefinition, definition);
  }

  postBirthPlanQuestionnaireDefinition(definition: any) {
    this.loggingService.log("Posting Birth Plan Questionnaire Definition", this.appConfigService.LogToConsole)
    return this.http.post(this.appConfigService.PostBirthPlanDefinition, definition);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/questionnaire-service/questionnaire.service.ts